import type { SVGProps } from "react";
const SenecPictogramDone = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M6 11C6 8.23858 8.23858 6 11 6H32C32.5523 6 33 6.44772 33 7C33 7.55228 32.5523 8 32 8H11C9.34315 8 8 9.34315 8 11V27C8 27.5523 7.55229 28 7 28C6.44772 28 6 27.5523 6 27V11Z"
            fill="currentColor"
        />
        <path
            d="M42 37C42 39.7614 39.7614 42 37 42L11 42C8.23857 42 6 39.7614 6 37V33C6 32.4477 6.44771 32 7 32C7.55228 32 8 32.4477 8 33L8 37C8 38.6569 9.34315 40 11 40L37 40C38.6569 40 40 38.6569 40 37V22C40 21.4477 40.4477 21 41 21C41.5523 21 42 21.4477 42 22V37Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.1213 9.70711C39.9497 8.53553 38.0503 8.53554 36.8787 9.70711L22 24.5858L20.1213 22.7071C18.9497 21.5355 17.0503 21.5355 15.8787 22.7071L15.7071 22.8787C14.5355 24.0503 14.5355 25.9497 15.7071 27.1213L22 33.4142L41.2929 14.1213C42.4645 12.9497 42.4645 11.0503 41.2929 9.87868L41.1213 9.70711ZM38.2929 11.1213C38.6834 10.7308 39.3166 10.7308 39.7071 11.1213L39.8787 11.2929C40.2692 11.6834 40.2692 12.3166 39.8787 12.7071L22 30.5858L17.1213 25.7071C16.7308 25.3166 16.7308 24.6834 17.1213 24.2929L17.2929 24.1213C17.6834 23.7308 18.3166 23.7308 18.7071 24.1213L22 27.4142L38.2929 11.1213Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramDone;
